import { get } from 'app/utils/axios/kheti'
import { LocationDetails } from "../models/location";

const fetchLocationDetails = async (pincode: string) => {
  try {
    const locationDetaills = await get<LocationDetails>(
      "/hyperlocal/v1/location_details",
      { pincode }
    );
    return locationDetaills;
  } catch (e) {
    console.error(e);
  }
  return null;
};

export default fetchLocationDetails;
